export const Visible = ({visible, children}) => {
  if(!visible) {
    return null;
  }
  return children; 
}